"use strict";

var ExportButton = require("app/shared/components/ExportButton/export-button");

var ExportDealsButton = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    skipOptions: React.PropTypes.bool
  },
  getExtraOptions: function(selectionValue) {
    return {
      includeOrgPersonData: (selectionValue >= 1 && selectionValue <= 2 ? 1 : 0),
      includeProductData: (selectionValue === 2 ? 1 : 0),
      includeFullProductData: (selectionValue === 3 ? 1 : 0)
    };
  },

  render: function() {
    let buttonText = this.props.skipOptions ? "Exportar negócios" : "Exportar";

    let options = [
      {
        value: 0,
        checked: true,
        text: "Negócios"
      },
      {
        value: 1,
        checked: false,
        text: "Negócios + detalhes de Empresas e Pessoas"
      },
      {
        value: 2,
        checked: false,
        text: "Negócios + detalhes de Empresas e Pessoas + Produtos",
        tooltip: "Produtos separados por vírgula, na mesma linha."
      },
      {
        value: 3 ,
        checked: false,
        text: "Negócios + detalhes de Produtos",
        tooltip: "Um produto por linha, com preço, quantidade, desconto, categoria."
      }
    ];

    return (
      <ExportButton
        onExport={this.props.onExport}
        getExtraOptions={this.getExtraOptions}
        options={options}
        skipOptions={this.props.skipOptions}
        buttonText={buttonText}
        exportName="negocio"
      />
    );
  }
});

module.exports = ExportDealsButton;



// WEBPACK FOOTER //
// ./app/screens/Deals/components/ExportDealsButton/export-deals-button.jsx